import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import settingsService from '../../services/settings.service';

const DEFAULT_STEPS = [
  { label: 'Elegí tu bono.', description: '' },
  { label: 'Comprá tu ticket.', description: '' },
  { label: 'Listo! Ya estás colaborando.', description: 'Recibís tu comprobante por mail.' },
];

export default function HowItWorksConfig() {
  const [steps, setSteps] = useState(DEFAULT_STEPS);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    settingsService
      .getHomeConfig()
      .then(data => {
        if (data?.howItWorksSteps?.length) setSteps(data.howItWorksSteps);
      })
      .catch(() => {});
  }, []);

  const update = (idx, field, value) => {
    setSteps(prev => prev.map((s, i) => (i === idx ? { ...s, [field]: value } : s)));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await settingsService.updateHomeConfig({ howItWorksSteps: steps });
      toast.success('Pasos actualizados');
    } catch {
      toast.error('Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const numbers = ['01.', '02.', '03.'];

  return (
    <div className='space-y-4'>
      <p className='text-sm text-muted-foreground'>
        Configurá los 3 pasos del proceso de compra que se muestran en la página de inicio.
      </p>
      <div className='space-y-4'>
        {steps.map((step, i) => (
          <div key={i} className='rounded-lg border border-border bg-background p-4 space-y-3'>
            <span className='text-lg font-bold italic text-primary/40'>{numbers[i]}</span>
            <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
              <div className='space-y-1'>
                <label className='text-xs font-medium text-foreground'>Título del paso</label>
                <Input
                  value={step.label}
                  onChange={e => update(i, 'label', e.target.value)}
                  placeholder={DEFAULT_STEPS[i].label}
                />
              </div>
              <div className='space-y-1'>
                <label className='text-xs font-medium text-foreground'>Descripción opcional</label>
                <Input
                  value={step.description}
                  onChange={e => update(i, 'description', e.target.value)}
                  placeholder='Nota adicional…'
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <Button onClick={handleSave} disabled={saving}>
        {saving && <Loader2 className='h-4 w-4 mr-2 animate-spin' />}
        Guardar pasos
      </Button>
    </div>
  );
}
